var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToastrSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9961 20C16.5189 20 20.9961 15.5228 20.9961 10C20.9961 4.47715 16.5189 0 10.9961 0C5.47325 0 0.996094 4.47715 0.996094 10C0.996094 15.5228 5.47325 20 10.9961 20ZM14.2321 6.5234C14.6102 6.12213 15.3111 6.19754 15.6998 6.5234C16.134 6.8873 16.0536 7.48814 15.6998 7.86357L10.413 13.4738C10.0734 13.8341 9.28308 13.85 8.94522 13.4738L6.2888 10.5158C5.92002 10.1052 5.8776 9.58464 6.2888 9.17563C6.64246 8.82386 7.41086 8.79069 7.75656 9.17563L9.69678 11.3361L14.2321 6.5234Z",
    fill: "#868FA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastrSuccess);
export default __webpack_public_path__ + "static/media/toastr-success.f7ed1c2e.svg";
export { ForwardRef as ReactComponent };